export default "17ae52e4c940b1b5.svg"